// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        suggestionMobileStyle: 'style2',
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    },
    selector: {
        otpProductItem: '.product-card'
    }
};
(function() {
    BoostPFS.inject(this);
    InstantSearchMobile.prototype.afterShowSearchBoxMobile = function(searchBoxId) {
        if (!searchBoxId) searchBoxId = this.searchBoxId;
        // Hide debut's search bar on mobile, and show our search bar instead
        if (jQ('.js-drawer-close').length > 0) {
            setTimeout(function() {
                jQ('.js-drawer-close').trigger('click');
            });
        }
    };
    SearchInput.prototype.customizeInstantSearch = function() {
        // Hide debut's search suggestion
        if (jQ('.predictive-search-wrapper').length > 0) {
            jQ('.predictive-search-wrapper').hide();
        }
    };

    function closeSuggestionMobile(searchBoxId, isCloseSearchBox) {
        /* console.log('closeSuggestionMobile'); */
        jQ(searchBoxId).autocomplete('close');
        jQ('.' + Class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').parent().hide();
        // Remove search box
        var isCloseSearchBox = typeof isCloseSearchBox !== 'undefined' ? isCloseSearchBox : false;
        if (isCloseSearchBox) jQ('.boost-pfs-search-suggestion-mobile-top-panel,.boost-pfs-search-suggestion-mobile-overlay').hide();
        // Update current term for all search boxes
        setValueAllSearchBoxes();
        // Add back tabindex=-1
        jQ('.boost-pfs-search-no-tabindex').attr('tabindex', -1);
        // Return scrolling of body
        if (jQ('body').hasClass(Class.searchSuggestionMobileOpen)) {
            jQ('body').removeClass(Class.searchSuggestionMobileOpen);
        }
        BoostPFS.afterCloseSuggestionMobile(searchBoxId, isCloseSearchBox);
        // Close search theme debut
        if (jQ('.js-drawer-close').length > 1) {
            jQ('.js-drawer-close').trigger('click');
        }
    }
  
    BoostOTP.inject(this);
    AddToCart.prototype.compileTemplate = function() {
        var productUrl = Utils.buildProductItemUrl(this.parent.data);
        var clickAction = '';
        var label = '';
        var variantId = '';
        var buttonClass = '';
        var productData = this.parent.data;
        var productListData = this.parent.parent.data;
        var productIsFirst = false;
        if (Array.isArray(productListData)) {
            productIsFirst = productData.id == productListData[0].id;
        } else if (Array.isArray(productListData.products)) {
            productIsFirst = productData.id == productListData.products[0].id;
        }
        var icoCart = Settings.getSettingValue('general.icoCart');
        var icoCartLink = Settings.getSettingValue('general.icoCartLink');
        if (productData.tags.includes('WarrantyProduct')) {
            return '';
        } else {
            if (productData.available) {
                if (productData.variants.length == 1) {
                    // Buy now if have 1 variant
                    clickAction = Settings.getSettingValue('general.enableAjaxCart') ? '' : 'type="submit"';
                    variantId = productData.variants[0].id;
                    label = Labels.action_list.atcAvailableLabel;
                    buttonClass = Class.atcAvailable;
                    this.type = AddToCart.Type.ADD_TO_CART;
                    this.variantId = variantId;
                } else {
                    // Select options (link to product page) if have > 1 variant
                    //clickAction = Settings.getSettingValue('general.enableAjaxCart') ?
                     //   'onclick="window.location.href=\'' + productUrl + '\'" type="button"' : ''
                    clickAction = 'onclick="window.location.href=\'' + productUrl + '\'" type="button"';
                    label = Labels.action_list.atcSelectOptionsLabel;
                    buttonClass = Class.atcSelectOptions;
                    this.type = AddToCart.Type.SELECT_OPTIONS;
                }
            } else {
                clickAction = 'disabled type="button"';
                label = Labels.action_list.atcSoldOutLabel;
                buttonClass = Class.atcSoldOut;
                this.type = AddToCart.Type.SOLD_OUT;
            }
            return this.getTemplate()
                .replace(/{{class.atcForm}}/g, Class.atcForm)
                .replace(/{{label}}/g, label)
                .replace(/{{variantId}}/g, variantId)
                .replace(/{{clickAction}}/g, clickAction)
                .replace(/{{buttonClass}}/g, buttonClass)
                .replace(/{{productUrl}}/g, productUrl)
                .replace(/{{icoCart}}/g, productIsFirst ? icoCart : icoCartLink);
        }
    }
  
    //Start boost 229654
    // Click notify button to go to PDP
    BoostOTP.AddToCart.prototype.afterRender = function() {
        if (this.$element && !Utils.isSearchPage()) {
            var self = this;
            var productData = self?.parent?.data;
            var buttonText = this.$element.find('.boost-pfs-addtocart-btn-text');
            if (buttonText?.text() == 'Notify Me' && productData) {
                buttonText.on('click', function() {
                    window.open(Utils.buildProductItemUrl(productData), '_blank');
                })
            }
        }
    }
    //End boost 229654
})();